import {useQuery} from '@tanstack/react-query'
import {QueryCacheKeys} from '../../QueryKey'
import {getProHistoryList} from '../../../apis/user/getProHistoryList'

const PAGE_SIZE = 1000

const useQueryProHistory = (currentPage?: number, end_at?: string) => {
    const {data, refetch} = useQuery({
        queryKey: QueryCacheKeys.user.getProHistoryList(),
        queryFn: async () => {
            const {data, pageInfo} = await getProHistoryList(PAGE_SIZE, currentPage, end_at)
            return {data, pageInfo}
        },
        refetchOnWindowFocus: false,
    })

    return {data, refetch}
}

export default useQueryProHistory
